import { pluralN } from "lib/useful";
import { useEffect } from "react";
import { useState } from "react";
import { store } from "react-recollect";
import { Button } from "./Buttons";
import Input from "./Input";
import RenderFieldColumn from "./RenderFieldColumn";
import ClickDiv from "./ClickDiv";

function RenderFieldTextChooser({
  field,
  setValue,
  localValue,
  resultsWrapClassName = "max-h-96",
  settingsKey,
}) {
  const [text, setText] = useState("");
  const [results, setResults] = useState(() =>
    settingsKey === "specs" ? store.settingsMap[settingsKey] : [],
  );

  useEffect(() => {
    const t = text.trim().toUpperCase();
    if (t === "") return;
    // filter to anything with this text in
    setResults(
      store.settingsMap[settingsKey].filter((d) => d.toUpperCase().includes(t)),
    );
  }, [text, settingsKey]);

  if (localValue) {
    return (
      <RenderFieldColumn leftContent={field.label} rightExtraClasses={"flex"}>
        <div className="w-1/2 p-3">
          <p className="font-semibold">{localValue}</p>
        </div>
        <div className="">
          <Button onClick={() => setValue(null)}>clear</Button>
        </div>
      </RenderFieldColumn>
    );
  }

  let exactMatch = results.find((r) => r.toUpperCase() === text.toUpperCase());
  if (!exactMatch && results.length === 1) exactMatch = results[0];
  function handleEnter() {
    if (exactMatch) setValue(exactMatch);
  }

  return (
    <RenderFieldColumn leftContent={field.label}>
      <div className="w-60">
        <Input value={text} setValue={setText} onEnter={handleEnter} />
        {exactMatch && (
          <div>
            <p>Press enter to select</p>
            <p className="text-xs"> {exactMatch} </p>
          </div>
        )}
      </div>
      <div className="flex-1 pl-3 py-1">
        {results.length < 1 ? (
          <p>No matches</p>
        ) : (
          <div
            className={`overflow-y-auto transition-all shadow-xl bg-white border-t-2 border-t-slate-400 ${resultsWrapClassName}`}
          >
            <p className="font-semibold m-3">
              {pluralN(results.length, "possible option")}
            </p>
            {results.map((f) => {
              return (
                <ClickDiv
                  key={f}
                  onClick={() => setValue(f)}
                  className="flex border cursor-pointer hover:border-emerald-600 hover:bg-emerald-50 m-1"
                >
                  <div className="p-1 ml-1">{f}</div>
                </ClickDiv>
              );
            })}
          </div>
        )}
      </div>
    </RenderFieldColumn>
  );
}

export default RenderFieldTextChooser;
